var React = require('react');

function Heroku (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 9 4 C 7.355469 4 6 5.355469 6 7 L 6 25 C 6 26.644531 7.355469 28 9 28 L 23 28 C 24.644531 28 26 26.644531 26 25 L 26 7 C 26 5.355469 24.644531 4 23 4 Z M 9 6 L 23 6 C 23.5625 6 24 6.4375 24 7 L 24 25 C 24 25.5625 23.5625 26 23 26 L 9 26 C 8.4375 26 8 25.5625 8 25 L 8 7 C 8 6.4375 8.4375 6 9 6 Z M 13 8 L 11 8.03125 C 11 8.03125 10.984375 17.039063 11 17 C 18.648438 13.40625 19 15.8125 19 15.8125 L 19 24 L 21 24 L 21 15.84375 C 21 10.816406 13 14 13 14 Z M 19.28125 8 C 19.28125 8 17.945313 9.84375 17 11 L 19.625 11 C 21.050781 9.15625 22 8 22 8 Z M 11 19 L 11 23.96875 L 14 21.5 Z"}));
}

Heroku.defaultProps = {"fill":"#000000","viewBox":"0 0 32 32","width":"32px","height":"32px"};

module.exports = Heroku;

Heroku.default = Heroku;
